import { db, storage } from "../Helpers/firebase";
import {
  GET_ALL_CHAT,
  GET_FIREBASE_MSG,
  GET_LAST_MSG,
  GET_ALL_DASBOARD_CHAT,
} from "./types";
import { toast } from "react-toastify";

import axios from "axios";

const config = {
  headers: {
    "Content-Type": "application/json",
    Authorization: localStorage.getItem("nonLoggedUserToken"),
  },
};

const PROXY = process.env.REACT_APP_URL + "api/";

export const addChat = (data) => async () => {
  try {
    const res = await axios.post(`${PROXY}chat/add-chat`, data);

    return res;
  } catch (err) {
    toast.error(err.response.data.message);
    return err;
  }
};

export const addChatByUser = () => async () => {
  try {
    const res = await axios.post(`${PROXY}chat/add-chat-staff`);
    return res;
  } catch (err) {

    if (localStorage.AppToken) {
      toast.error(err.response.data.message);
    } else {
      toast.error("Please login to access this feature");
    }
    return err;
  }
};

export const addChatByGuest = () => async () => {
  try {
    const res = await axios.post(
      `${PROXY}chat/add-chat-staff`,
      {},
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("nonLoggedUserToken"),
        },
      }
    );
    return res;
  } catch (err) {
    toast.error(err.response.data.message);

    return err;
  }
};

export const getNonRegisteredUserId = (data) => async () => {
  try {
    const res = await axios.post(`${PROXY}user/non-register-chat`, data);
    return res;
  } catch (err) {
    toast.error(err.response.data.message);
  }
};

export const readAllMessage = (data, isRead, userId) => async (dispatch) => {
  const res = db
    .collection("messages")
    .doc(data)
    .collection(data)
    .where("groupId", "==", data)
    .where("flag", "in", [1, 3])
    .get()
    .then((snap) => {
      snap.docs.forEach((doc) => {
        if (true == isRead) {
          // console.log(isRead);
          let batch = db.batch();
          const ref = doc.ref;
          console.log("reached");
          batch.update(ref, { fromUnread: 1 });
          return batch.commit();
        } else {
          return null;
        }
      });
    });
  return true;
};

export const getAllMessage = (data, userId) => async (dispatch, getState) => {
  const res = await db
    .collection("messages")
    .doc(data?.toString())
    .collection(data)
    .orderBy("timestamp", "asc")
    .onSnapshot(async (doc) => {
      let message = [];
      doc.forEach(async (s) => {
        message.push(s.data());
      });
      // await db
      //   .collection("messages")
      //   .doc(data?.toString())
      //   .collection(data)
      //   .where("fromUnread", "==", 0)
      //   .where("to", "==", userId)
      //   .where("groupId", "==", data)
      //   .get()
      //   .then((snap) => {
      //     snap.docs.forEach((doc) => {
      //       let batch = db.batch();
      //       const ref = doc.ref;
      //       batch.update(ref, { fromUnread: 1 });

      //       return batch.commit();
      //     });
      //   });

      dispatch({
        type: GET_FIREBASE_MSG,
        payload: message,
      });
    });

  return res;
};

export const sendMessage = (data) => async (dispatch) => {
  try {
    const res = await db.collection("messages").doc(data.id).get();
    let newObj = {};

    newObj.from = data.from;
    newObj.message = data.message;
    newObj.to = data.to;
    newObj.timestamp = new Date();
    newObj.fromUnread = 0; // Unread = 0 and Read =1
    newObj.groupId = data.id;
    newObj.flag = 2;

    if (data.message) {
      newObj.type = "text";
    } else {
      newObj.type = "image";
    }

    if (res.exists) {
      let docRef = db.collection("messages").doc(data.id);
      await db.runTransaction(async (transaction) => {
        transaction.set(docRef, newObj);
      });

      await db
        .collection("messages")
        .doc(data.id)
        .collection(data.id)
        .doc(new Date().getTime().toString())
        .set(newObj);
    } else {
      let docRef = db.collection("messages").doc(data.id);
      await db.runTransaction(async (transaction) => {
        transaction.set(docRef, newObj);
      });

      await db
        .collection("messages")
        .doc(data.id)
        .collection(data.id)
        .doc(new Date().getTime().toString())
        .set(newObj);
    }
  } catch (err) {
    console.error(err);
  }
};

export const getAllChat = (userId) => async (dispatch) => {

  try {
    let res = await axios.get(`${PROXY}chat/get-all-chat-user`);
    // for (let i = 0; i < res.data.result.length; i++) {
    //   let element = res.data.result[i];
    //   await db
    //     .collection("messages")
    //     .doc(element._id.toString())
    //     .onSnapshot(async (doc) => {
    //       const last = await doc.data();
    //       if (last) {
    //         element.last = last;
    //       }
    //       if (last === undefined || !last) {
    //         element.last = {
    //           from: "",
    //           fromUnread: "",
    //           message: "",
    //           timestamp: { nanoseconds: 1, seconds: i + 1 },
    //         };
    //       }
    //     });

    //   await db
    //     .collection("messages")
    //     .doc(element._id?.toString())
    //     .collection(element._id)

    //     .orderBy("timestamp", "asc")
    //     .onSnapshot((doc) => {
    //       let message = [];

    //       doc.forEach(async (s) => {
    //         message.push(s.data());

    //         const unreads = message.filter(
    //           (val) => val.to === userId && val.fromUnread === 0
    //         );

    //         element["unreads"] = unreads.length;
    //       });
    //     });
    // }

    dispatch({
      type: GET_ALL_CHAT,
      payload: res.data.result,
    });
    return res.data.result;
  } catch (err) {
    console.error(err);
  }
};
export const getAllDashboardChat = (userId) => async (dispatch) => {

  try {
    let res = await axios.get(`${PROXY}chat/get-all-chat-user`);
    // for (let i = 0; i < res.data.result.length; i++) {
    //   let element = res.data.result[i];
    //   await db
    //     .collection("messages")
    //     .doc(element._id.toString())
    //     .onSnapshot(async (doc) => {
    //       element.last = await doc.data();
    //     });

    //   await db
    //     .collection("messages")
    //     .doc(element._id?.toString())
    //     .collection(element._id)
    //     .orderBy("timestamp", "asc")
    //     .onSnapshot((doc) => {
    //       let message = [];

    //       doc.forEach(async (s) => {
    //         message.push(s.data());

    //         const unreads = message.filter(
    //           (val) => val.to === userId && val.fromUnread === 0
    //         );

    //         element["unreads"] = unreads.length;
    //       });
    //     });
    // }

    dispatch({
      type: GET_ALL_DASBOARD_CHAT,
      payload: res.data.result,
    });
    return res.data.result;
  } catch (err) {
    console.error(err);
  }
};

export const getChat = (page, limit) => async (dispatch) => {
  console.log("non-logged-in-user");
  try {
    let res = await axios.get(`${PROXY}chat/get-all-chat-user`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("nonLoggedUserToken"),
      },
    });

    // for (let i = 0; i < res.data.result.length; i++) {
    //   let element = res.data.result[i];

    //   await db
    //     .collection("messages")
    //     .doc(element._id.toString())
    //     .onSnapshot(async (doc) => {
    //       element.last = await doc.data();
    //     });

    //   await db
    //     .collection("messages")
    //     .doc(element._id?.toString())
    //     .collection(element._id)
    //     .orderBy("timestamp", "asc")
    //     .onSnapshot((doc) => {
    //       let message = [];
    //       doc.forEach(async (s) => {
    //         message.push(s.data());

    //         const unreads = message.filter((val) => val.fromUnread === 0);

    //         element["unreads"] = unreads.length;
    //       });
    //     });

    // }

    dispatch({
      type: GET_ALL_CHAT,
      payload: res.data.result,
    });
    return res.data.result;
  } catch (err) {
    console.error(err);
  }
};

export const getLAstMessage = (data) => async (dispatch) => {
  return new Promise(async (resolve, reject) => {
    await db
      .collection("messages")
      .doc(data?.toString())
      .onSnapshot((doc) => {
        resolve(doc.data());
        // dispatch({
        //   type: GET_LAST_MSG,
        //   payload: doc.data(),
        // });
      });
  });
};

export const fileUpdateFB = (imageAsFile, data) => async (dispatch) => {
  const uploadTask = storage
    .ref(`/images/${imageAsFile.name}`)
    .put(imageAsFile);

  uploadTask.on(
    "state_changed",
    (snapShot) => {
      //takes a snap shot of the process as it is happeninggroupId
    },
    (err) => {
      //catches the errors
    },
    () => {
      // gets the functions from storage refences the image storage in firebase by the children
      // gets the download url then sets the image from firebase as the value for the imgUrl key:
      storage
        .ref("images")
        .child(imageAsFile.name)
        .getDownloadURL()
        .then(async (fireBaseUrl) => {
          const res = await db.collection("messages").doc(data.id).get();
          let newObj = {};

          newObj.from = data.from;
          newObj.to = data.to;
          newObj.timestamp = new Date();
          newObj.image = fireBaseUrl;
          newObj.type = "image";
          newObj.fromUnread = 0; // Unread = 0 and Read =1
          newObj.groupId = data.id;
          newObj.flag = 2;

          if (res.exists) {
            let docRef = db.collection("messages").doc(data.id);
            await db.runTransaction(async (transaction) => {
              transaction.set(docRef, newObj);
            });
            await db
              .collection("messages")
              .doc(data.id)
              .collection(data.id)
              .doc(new Date().getTime().toString())
              .set(newObj);
          } else {
            let docRef = db.collection("messages").doc(data.id);
            await db.runTransaction(async (transaction) => {
              transaction.set(docRef, newObj);
            });
            await db
              .collection("messages")
              .doc(data.id)
              .collection(data.id)
              .doc(new Date().getTime().toString())
              .set(newObj);
          }
        });
    }
  );
};

export const userOffline = () => async () => {
  try {
    await axios.get(`${PROXY}chat/user-offline`);
  } catch (err) {
    console.error(err);
  }
};

export const deleteChat = (id) => async (dispatch) => {
  try {
    const res = await axios.delete(`${PROXY}chat/delete/${id}`);

    return res;
  } catch (err) {
    toast.error(err.response.data.message);
    return err;
  }
};
